import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 01AD77CD-8F92-4E32-A752-387203BC9FF8
 * name arrow-bottom-right-thick
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-right-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomRightThickIcon = createSvgIcon(<><path d="M14.89,12.06V7.11H18.31V18.31H7.11V14.89H12.06L5.69,8.5L8.5,5.69L14.89,12.06Z" /></>, 'ArrowBottomRightThickIcon');
export default ArrowBottomRightThickIcon